"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_REPORT_VIEWED = exports.SYNC_STATUS = exports.SYNC_DATA = exports.RECORD_REVAMP_COUNT = exports.POST_MY_PRESCRIPTION = exports.ORDER_PRESCRIPTION_TICKET_NOTIFICATION = exports.MY_RECORDS = exports.MARK_RECORD_VIEWED = exports.GUEST_FLOW_LAB_REPORTS = exports.GET_MY_PRESCRIPTIONDETAILS = exports.GET_MY_PRESCRIPTION = exports.GET_LAB_REPORT_SUMMARY = exports.GET_ALL_RECORDS_LIST = exports.CANCEL_YELLOW_TOAST = void 0;
const MY_RECORDS = exports.MY_RECORDS = 'myRecords';
const GET_MY_PRESCRIPTION = exports.GET_MY_PRESCRIPTION = 'myPrescriptionDetails';
const POST_MY_PRESCRIPTION = exports.POST_MY_PRESCRIPTION = 'myPrescriptionOrderDetails';
const ORDER_PRESCRIPTION_TICKET_NOTIFICATION = exports.ORDER_PRESCRIPTION_TICKET_NOTIFICATION = 'myPrescriptionOrderTicketNotificationDetails';
const GET_MY_PRESCRIPTIONDETAILS = exports.GET_MY_PRESCRIPTIONDETAILS = 'myPrescriptionDetails';
const SYNC_STATUS = exports.SYNC_STATUS = 'syncStatus';
const SYNC_DATA = exports.SYNC_DATA = 'syncData';
const GET_LAB_REPORT_SUMMARY = exports.GET_LAB_REPORT_SUMMARY = 'labsOnHomeSummary';
const UPDATE_REPORT_VIEWED = exports.UPDATE_REPORT_VIEWED = 'labsOnHomeMarkReportViewd';
const GUEST_FLOW_LAB_REPORTS = exports.GUEST_FLOW_LAB_REPORTS = 'guestFlowLabReports';
const GET_ALL_RECORDS_LIST = exports.GET_ALL_RECORDS_LIST = 'getAllRecordsInList';
const MARK_RECORD_VIEWED = exports.MARK_RECORD_VIEWED = 'markRecordViewed';
const CANCEL_YELLOW_TOAST = exports.CANCEL_YELLOW_TOAST = 'cancelYellowToast';
const RECORD_REVAMP_COUNT = exports.RECORD_REVAMP_COUNT = 'recordRevampCount';